import React from "react";
import { Modal, message } from "antd";

export default function TechCardModal({
  formContext,
  width,
  children,
  title,
  isOpen,
  setOpen,
  handleSubmit,
  submitIsDisabled,
  changeData,
  setChangeData,
  loading = false,
  okText = "Подтвердить",
  cancelText = "Отмена",
  onCancel,
  destroyOnClose = false,
  maskClosable = true,
}) {
  const handleOk = async () => {
    console.log("TechCardModal: handleOk triggered");
    try {
      console.log("TechCardModal: Validating form...");
      const values = await formContext.validateFields();
      console.log("TechCardModal: Form validated successfully, values:", JSON.stringify(values, null, 2));
      await handleSubmit(values);
      console.log("TechCardModal: handleSubmit completed successfully");
      setOpen(false);
      formContext.resetFields();
    } catch (error) {
      console.error("TechCardModal: Error in handleOk:", error);
      if (error.errorFields && error.errorFields.length > 0) {
        error.errorFields.forEach((err) => {
          console.log("Validation error in field:", err.name, err.errors);
          message.error(`Ошибка в поле ${err.name.join(".")}: ${err.errors.join(", ")}`);
        });
      } else {
        message.error("Произошла ошибка при отправке формы");
      }
    }
    if (setChangeData) setChangeData(false);
  };

  const handleCancelInternal = () => {
    console.log("TechCardModal: handleCancel triggered");
    if (changeData) {
      Modal.confirm({
        title: "Подтвердите действие",
        content: "Вы действительно хотите закрыть окно? Все несохраненные данные будут потеряны.",
        okText: "Да",
        cancelText: "Нет",
        onOk: () => {
          setOpen(false);
          formContext.resetFields();
          if (onCancel) onCancel();
          if (setChangeData) setChangeData(false);
        },
      });
    } else {
      setOpen(false);
      formContext.resetFields();
      if (onCancel) onCancel();
      if (setChangeData) setChangeData(false);
    }
  };

  return (
    <Modal
      open={isOpen}
      width={width || 800}
      title={title}
      onOk={handleOk}
      okButtonProps={{
        disabled: submitIsDisabled,
        loading: loading,
      }}
      onCancel={handleCancelInternal}
      okText={okText}
      cancelText={cancelText}
      destroyOnClose={destroyOnClose}
      maskClosable={maskClosable}
    >
      {children}
    </Modal>
  );
}